angular.module('zc.master')
  .component('zcLogisticRegressionCoefficients', {
    templateUrl: '/templates/master/components/logistic_regression_coefficients/logistic_regression_coefficients.html',
    bindings: {
      apikey: '<',
      preferredDevice: '<'
    },
    controller: logisticRegressionCoefficientsController,
  });

logisticRegressionCoefficientsController.$inject = ['$scope', '$filter', 'MasterMongoLogisticRegressionCoefficients'];
function logisticRegressionCoefficientsController($scope, $filter, MasterMongoLogisticRegressionCoefficients) {
  const vm = this;

  const FIELD_DICTIONARY = {
    session_history_count: $filter('translate')('sessionHistoryCount'),
    session_interest_count: $filter('translate')('sessionInterestCount'),
    session_cart_button_click_count: $filter('translate')('sessionCartButtonClickCount'),
    session_repeat_item_count: $filter('translate')('sessionRepeatItemCount'),
    session_page_types_counts_category: $filter('translate')('sessionPageTypesCountsCategory'),
    session_page_types_counts_feature: $filter('translate')('sessionPageTypesCountsFeature'),
    session_page_types_counts_item: $filter('translate')('sessionPageTypesCountsItem'),
    session_page_types_counts_sale: $filter('translate')('sessionPageTypesCountsSale'),
    session_page_types_counts_search: $filter('translate')('sessionPageTypesCountsSearch'),
    session_page_types_counts_top: $filter('translate')('sessionPageTypesCountsTop'),
    session_second_page_types: $filter('translate')('sessionSecondPageTypes'),
    session_landing_page_types: $filter('translate')('sessionLandingPageTypes'),
    session_average_interest_item_price: $filter('translate')('sessionAverageInterestItemPrice'),
    session_is_login: $filter('translate')('sessionIsLogin'),
    session_is_advertising: $filter('translate')('sessionIsAdvertising'),
    session_is_newsletter: $filter('translate')('sessionIsNewsletter'),
    session_segment_total_conversion_count: $filter('translate')('sessionSegmentTotalConversionCount'),
    session_segment_session_count: $filter('translate')('sessionSegmentSessionCount'),
    session_segment_has_been_login: $filter('translate')('sessionSegmentHasBeenLogin'),
    session_segment_is_cart_abandoned: $filter('translate')('sessionSegmentIsCart_abandoned'),
    session_segment_is_interest_dropped: $filter('translate')('sessionSegmentIsInterestDropped'),
    session_user_agent_os_name: $filter('translate')('sessionUserAgentOsName'),
    session_user_agent_browser_name: $filter('translate')('sessionUserAgentBrowserName'),
  };

  vm.$onInit = () => {
    vm.limit = 10;
    vm.sortProp = 'value';
    vm.sortDirection = 'desc';
    vm.device = 'pc';
    if(vm.preferredDevice === 'pc' || vm.preferredDevice === 'sp') {
      vm.device = vm.preferredDevice;
    }
    vm.coefficients = [];
    vm.currentCoefficients = null;
    vm.createdAt = null;
    vm.partials = null;
    vm.changeLimit = changeLimit;
    vm.sortBy = sortBy;
    $scope.$watch('$ctrl.device', setCurrentCoefficients);
    findCoefficients();
  };

  function findCoefficients() {
    MasterMongoLogisticRegressionCoefficients.find({
      match: {
        apikey: vm.apikey,
        is_active: true
      },
      fields: ['device', 'partial', 'created_at']
    })
      .then(coefficients => {
        vm.coefficients = coefficients;
        setCurrentCoefficients();
      });
  }

  function setCurrentCoefficients() {
    const current = _.find(vm.coefficients, {device: vm.device});
    if(current) {
      vm.partials = getOrderedPartials(current.partial);
      vm.createdAt = current.created_at;
    } else {
      vm.partials = null;
      vm.createdAt = null;
    }
  }

  function getOrderedPartials(partials) {
    const reverse = vm.sortDirection === 'desc';
    partials = _.map(partials, (value, key) => {
      return {
        key: key,
        label: translate(key),
        value: value
      };
    });
    partials = _.reject(partials, partial => partial.value === 0 );
    partials = $filter('orderBy')(partials, vm.sortProp, reverse);
    partials = $filter('emptyToEnd')(partials, vm.sortProp, reverse);
    return _.take(partials, vm.limit);
  }

  function changeLimit(limit) {
    vm.limit = limit;
    setCurrentCoefficients();
  }

  function sortBy(key) {
    if(vm.sortProp === key) {
      if(vm.sortDirection === 'desc') {
        vm.sortDirection = 'asc';
      } else {
        vm.sortDirection = 'desc';
      }
    } else {
      vm.sortProp = key;
      vm.sortDirection = 'desc';
    }
    setCurrentCoefficients();
  }

  function translate(from) {
    let to = '';
    for(let key in FIELD_DICTIONARY) {
      if(_.startsWith(from, key)) {
        from = from.replace(key, '');
        to += FIELD_DICTIONARY[key];
        break;
      }
    }
    const words = from.replace(/_+/, '').split(/_+/);
    if(_.endsWith(from, 'eq')) {
      to += $filter('translate')('eq', { words: words[0] });
    } else if(_.endsWith(from, 'in_range')) {
      to += $filter('translate')('inRange', { words0: words[0], words1: words[1] });
    } else if(_.endsWith(from, 'isin')) {
      to += $filter('translate')('isin', { words: words[0] });
    } else if(_.endsWith(from, 'log1p')) {
      to += $filter('translate')('log1p');
    } else if(_.endsWith(from, 'min')) {
      to += $filter('translate')('min', { words: words[0] });
    }
    return to;
  }
}



// WEBPACK FOOTER //
// ./src/master_admin_modules/master/components/logistic_regression_coefficients/logistic_regression_coefficients.js